import * as Backbone from 'backbone';
import { randomString, escapeHtml } from 'sma.common/utils';

const TEMPLATES = {
	baseFileViewer: require('sma.common/components/partials/file_previewer/base.mustache'),
	fileViewerBar: require('sma.common/components/partials/file_previewer/bar.mustache'),
	fileViewerDocument: require('sma.common/components/partials/file_previewer/document.mustache'),
	fileViewerImage: require('sma.common/components/partials/file_previewer/image.mustache'),
	fileViewerVideo: require('sma.common/components/partials/file_previewer/video.mustache'),
	fileViewerAudio: require('sma.common/components/partials/file_previewer/audio.mustache'),
	fileFiewerLinkedVideo: require('sma.common/components/partials/file_previewer/linked_video.mustache'),
	fileViewerCantPreview: require('sma.common/components/partials/file_previewer/no_preview.mustache'),
	excelTable: require('sma.common/components/partials/file_previewer/excel_table.mustache')
};

const STRINGS = {
	download: gettext('DOWNLOAD'),
	files: gettext('files'),
	cantDisplay: gettext('The file format cannot be displayed in the browser.')
};

class FilePreviewer extends Backbone.View {
	get events() {
		return {
			'click .sma-file-viewer-previous-file': 'previousFile',
			'click .sma-file-viewer-next-file': 'nextFile',
			'click .sma-file-viewer': 'closeViewer',
			'click .sma-file-viewer-bar': 'stopPropagation',
			'click .sma-file-viewer-media': 'stopPropagation',
			'click .sma-file-viewer-linked-video-inner-wrap': 'stopPropagation',
			'click .sma-file-viewer-close': 'closeViewer'
		};
	}

	static convertLinkedVideoToEmbeddedURL(url) {
		url = decodeURIComponent(url);
		const vimeoPattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
		const youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;

		// Check if it's already the embedded link (probably not the best way, but it's aight)
		if (url.includes('player.') || url.includes('/embed/')) {
			return url;
		} else {
			if (vimeoPattern.test(url)) {
				url = url.replace(vimeoPattern, 'https://player.vimeo.com/video/$1');
			} else if (youtubePattern.test(url)) {
				const youtubeID = FilePreviewer.getYoutubeID(url);
				url = `https://www.youtube.com/embed/${youtubeID}`;
			}
		}
		return url;
	}

	static getYoutubeID(url) {
		const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
		const match = url.match(regExp);

		return (match && match[2].length === 11) ? match[2] : null;
	}

	/**
	 * @param {Object[]} files - Files to populate the viewer with
	 */
	initialize(config) {
		if (!config) {
			console.warn('Missing parameter: "config"');
			return;
		}

		if (!config.hasOwnProperty('files')) {
			console.warn('Missing property: "files"');
			return;
		}

		this.files = config.files;
		this.indexOfActiveFile = config.indexOfActiveFile || 0;
		this.id = randomString(20);

		// Generic key events to traverse the file viewer
		$(document).on('keyup', (_e) => {
			if (_e.keyCode === 27) { // Escape
				this.closeViewer();
			} else if (_e.keyCode === 37) { // Left arrow
				this.previousFile();
			} else if (_e.keyCode === 39) { // Right arrow
				this.nextFile();
			}
		});
		this.files.forEach((file) => {
			file.url = FilePreviewer.convertLinkedVideoToEmbeddedURL(file.url);
		});
		this.render();
	}

	render() {
		let renderedBase = TEMPLATES.baseFileViewer({
			id: this.id,
		});

		$('body').prepend(renderedBase);

		this.viewer = $('#' + this.id);
		this.setElement(this.viewer);

		this.populateViewerWithFileData();
	}

	populateViewerWithFileData() {
		let file = this.files[this.indexOfActiveFile];
		file.icon = this.activeFileIcon();

		// Generate download attribute with escaped filename
		let downloadAttr = '';
		if (file.filename) {
			const escapedFilename = escapeHtml(file.filename);
			downloadAttr = `download="${escapedFilename}"`;
		} else if (file.name) {
			const escapedName = escapeHtml(file.name);
			downloadAttr = `download="${escapedName}"`;
		} else {
			downloadAttr = 'download';
		}

		// FILE VIEWER BAR
		let fileViewerBar = this.viewer.find('.sma-file-viewer-bar');
		let disableNavButtons = this.files.length === 1 ? true : false;
		let fileViewerBarRendered = TEMPLATES.fileViewerBar({
			index: this.indexOfActiveFile + 1,
			numFiles: this.files.length,
			file: file,
			strings: STRINGS,
			enableDownload: file.type !== 'link',
			disableNavButtons: disableNavButtons,
			downloadAttr: downloadAttr,
		});
		fileViewerBar.html(fileViewerBarRendered);

		// FILE VIEWER CONTENT AREA
		const fileViewerCanvas = this.viewer.find('.sma-file-viewer-content');
		const template = this.activeFileTemplate();

		if (this.fileIsPdf(file)) {
			file.src = `/static/js/pdfjs/web/viewer.html?file=${encodeURIComponent(file.url)}`;
		} else if (file.converted_url) {
			file.src = `/static/js/pdfjs/web/viewer.html?file=${encodeURIComponent(file.converted_url)}`;
		}

		let fileViewerCanvasRendered = template({
			file: file,
			strings: STRINGS,
			downloadAttr: downloadAttr,
		});
		fileViewerCanvas.html(fileViewerCanvasRendered);
	}

	stopPropagation(e) {
		e.stopPropagation();
	}

	closeViewer(_e) {
		this.destroy();
	}

	nextFile(_e) {
		// Last file in the list
		if (this.indexOfActiveFile + 1 == this.files.length) {
			this.indexOfActiveFile = 0;
		} else {
			this.indexOfActiveFile += 1;
		}
		this.populateViewerWithFileData();
	}

	previousFile(_e) {
		// First file in the list
		if (this.indexOfActiveFile == 0) {
			this.indexOfActiveFile = this.files.length - 1;
		} else {
			this.indexOfActiveFile -= 1;
		}
		this.populateViewerWithFileData();
	}

	activeFileIcon() {
		let file = this.files[this.indexOfActiveFile];
		switch (file.type) {
			case 'file':
				return 'files_single-content-03';
			case 'image':
				return 'files_image';
			case 'video':
				return 'files_play';
			case 'audio':
				return 'files_music';
			case 'link':
				return 'ui-2_link-72';
			default:
				return 'files_single-folded';
		}
	}

	fileIsPdf(file) {
		const isPdfRegex = /\.pdf.*$/i;
		return isPdfRegex.test(file.url);
	}

	activeFileTemplate() {
		let file = this.files[this.indexOfActiveFile];

		if (file.show_table_sheet && (file.file_extension.toLowerCase() == 'csv' || file.file_extension.toLowerCase() == 'xlsx' || file.file_extension.toLowerCase() == 'xls')) {
			return TEMPLATES.excelTable;
		}

		if (file.converted_url || this.fileIsPdf(file)) {
			return TEMPLATES.fileViewerDocument;
		}

		switch (file.type) {
			case 'file':
				return TEMPLATES.fileViewerImage;
			case 'image':
				return TEMPLATES.fileViewerImage;
			case 'video':
				return TEMPLATES.fileViewerVideo;
			case 'audio':
				return TEMPLATES.fileViewerAudio;
			case 'link':
				return TEMPLATES.fileFiewerLinkedVideo;
			default:
				return TEMPLATES.fileViewerCantPreview;
		}
	}

	destroy() {
		this.viewer.remove();
	}
}

module.exports = FilePreviewer;
